var $4f76f1f805f21373$exports = {};
$4f76f1f805f21373$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$4f76f1f805f21373$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
